/**
 * 목록 컬럼 머리 (2026-08-21) — 전체 선택 + 칸 이름.
 *
 * 목록이 넓을 때(닫힘·상하열림)만 뜻이 있다 — 좁아지면 줄이 세 줄 카드가 되어 칸이 사라진다.
 * 그래서 보이고 감추는 것은 CSS 컨테이너 질의가 한다(MailPageView.css).
 *
 * ★ 전체 선택은 **지금 쪽**만 고른다. 메일함 전체를 한 번에 다루는 것은 서버가 폴더 단위로
 *   받아 줘야 하는 일이다(아직 없다) — 있는 척하면 스무 통만 바뀌고 끝난다.
 */

import { tMail } from '../../lib/mail-i18n';

interface MailListHeadProps {
  /** 지금 쪽에 보이는 통수 — 0 이면 머리를 감춘다. */
  count: number;
  allPicked: boolean;
  somePicked: boolean;
  onToggleAll: () => void;
}

export function MailListHead({ count, allPicked, somePicked, onToggleAll }: MailListHeadProps) {
  if (count === 0) return null;
  return (
    <div className="mail-list-colhead">
      <label className="mail-list-colhead-check">
        <input
          type="checkbox"
          checked={allPicked}
          ref={(el) => { if (el) el.indeterminate = !allPicked && somePicked; }}
          onChange={onToggleAll}
          aria-label={tMail('mail.colhead.select_all')}
        />
      </label>
      <span className="mail-list-colhead-star" aria-hidden />
      <span className="mail-list-colhead-avatar" aria-hidden />
      <span className="mail-list-colhead-sender">{tMail('mail.colhead.sender')}</span>
      <span className="mail-list-colhead-subject">{tMail('mail.colhead.subject')}</span>
      <span className="mail-list-colhead-time">{tMail('mail.colhead.date')}</span>
    </div>
  );
}
